export default "__VITE_ASSET__CQmrYOMI__"